import { __extends } from "tslib";
import { ShaderDefineExpression } from "../shaderDefineExpression.js";
/** @hidden */
var ShaderDefineOrOperator = /** @class */ (function (_super) {
    __extends(ShaderDefineOrOperator, _super);
    function ShaderDefineOrOperator() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ShaderDefineOrOperator.prototype.isTrue = function (preprocessors) {
        return this.leftOperand.isTrue(preprocessors) || this.rightOperand.isTrue(preprocessors);
    };
    return ShaderDefineOrOperator;
}(ShaderDefineExpression));
export { ShaderDefineOrOperator };
//# sourceMappingURL=shaderDefineOrOperator.js.map